const SITE_KEY =
  process.env.REACT_APP_RECAPTCHA_SITE_KEY ||
  "6LdoJR8sAAAAACJ93tdlv1O8rCCO1_XPfSHsuO3G";

export async function executeCaptcha(action) {
  if (!window.grecaptcha || !SITE_KEY) return "";

  try {
    await new Promise((resolve) => window.grecaptcha.ready(resolve));
    return await window.grecaptcha.execute(SITE_KEY, { action });
  } catch (err) {
    console.error("reCAPTCHA execution failed:", err);
    return "";
  }
}
